import { render, staticRenderFns } from "./RecurringViberCampaignCreateRoute.vue?vue&type=template&id=4760ec02&scoped=true&"
import script from "./RecurringViberCampaignCreateRoute.vue?vue&type=script&lang=js&"
export * from "./RecurringViberCampaignCreateRoute.vue?vue&type=script&lang=js&"
import style0 from "./RecurringViberCampaignCreateRoute.vue?vue&type=style&index=0&id=4760ec02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760ec02",
  null
  
)

export default component.exports